import { type FC } from 'react';

import { useMediaQuery } from '@/hooks/useMediaQuery';

import * as S from './PaymentWaySkeleton.styles';

export const PaymentWaySkeleton: FC = () => {
  const isMobile = useMediaQuery('mobile');

  const rows = Array.from({ length: 5 });

  return (
    <S.Wrapper data-testid="payment-way-skeleton" aria-hidden="true">
      <S.Header>
        <S.SkeletonLine width={20} height={12} />
        {!isMobile && <S.SkeletonLine width={20} height={12} />}{' '}
      </S.Header>

      <S.List>
        {rows.map((_, i) => (
          <S.Row key={`pay-row-skeleton-${i}`}>
            <S.Circle />
            <S.SkeletonLine width={100} height={12} />
          </S.Row>
        ))}
      </S.List>
    </S.Wrapper>
  );
};
